export default __webpack_public_path__ + "static/media/address-guide-mobile.2684f52b.png";